/* istanbul ignore file */
import '@teladoc/effra/all.css';
import 'react-toastify/dist/ReactToastify.css';
import 'react-datepicker/dist/react-datepicker.css';
import './index.css';

import 'focus-visible';
import 'wicg-inert';

import React from 'react';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';

import App from './App';
import * as serviceWorker from './serviceWorker';

Modal.setAppElement('#root');

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
